// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__qwOi1","ellipsis":"styles_ellipsis__0mvQF","text2AndMoreLines":"styles_text2AndMoreLines___wx3x","tooltipTrigger":"styles_tooltipTrigger__ICERv"};